import React from "react"
import { Box, Button, ButtonGroup, Grid } from "@mui/material"
import BSSButton from "../../form/BSSButton"
import __t from "../../../lib/traduzioni"
import useBSSLogger from "../../../hooks/useBSSLogger"

const {logger} = useBSSLogger();


const FrammentoSubmitCarrello = ({methods, classes, onSubmit, gridProps={}, buttonProps={}}) => {


    /**
     * Il contesto può essere salvaeaggiungi o paga
     * Se il submit va in successo
     * Sposta in storage il contenuto di spedizioniweb2_preventivo_form dentro spedizioniweb2_preventivo_carrello
     * Se il contesto è salvaeaggiungi torno alla prima pagina del preventivo
     * Se il contesto è paga apre il carrello così da permettere all'utente di inserire
     * 
     */
    const submit = async (contesto) =>{        
        try {
            const esitoSubmit = await onSubmit(contesto)
        } catch(err){
            logger.debug("errore non effettuo submit per il contesto", contesto, err)
        }
        
    }

    return (
        
            <Grid item xs={12} className={classes.formGroupBox} {...gridProps}>
                        
                <ButtonGroup fullWidth variant="contained" size="large" color="primary">
                    
                    <BSSButton methods={methods} onClick={e => submit("salvaeaggiungi")}
                        className={classes.noRightRadius}
                        {...buttonProps}
                    >
                        {__t("salvacarrelloenuovo")}
                    </BSSButton>
                    
                    <BSSButton methods={methods} onClick={e => submit("paga")} 
                        className={classes.noLeftRadius} {...buttonProps} >
                        {__t("vaiaipagamenti")}
                    </BSSButton>            

                </ButtonGroup>            
                
            </Grid>
        
        
    )
}

export default FrammentoSubmitCarrello